import {
  CONSUMER_CMS_SHOPPING_CART,
  IPortabilityMobileCMS,
  IPortInfoResponse,
  useCmsConfig,
} from '@vfit/consumer/data-access';
import { API, getFromLocalStorageByKey, trackLink } from '@vfit/shared/data-access';
import { useEffect } from 'react';
import { IPortabilityObject } from '@vfit/shared/models';
import { ICheckoutData } from '../../checkout.models';
import PortabilityMigrationData from './components/PortabilityMigrationData/PortabilityMigrationData';
import { useCheckout } from '../../../iBuyMobile.context';
import { evaluatePortabilityLabels } from './portabilityDataCard.utils';
import TaggingPortabilityDataCard from './portabilityDataCard.tagging';

const PortabilityDataCard = ({ handleOnChangeEnableGoNext }: ICheckoutData) => {
  const { portability, product, setPortability, setIsValidNumberPortability } = useCheckout();
  const portabilityInfo: IPortInfoResponse = getFromLocalStorageByKey('portabilityInfo');
  const availableOperators =
    portabilityInfo?.portInDetails?.mobilePortInDetails?.[0]?.portInProviderCust?.availableValues;
  const currentPlan =
    portabilityInfo?.portInDetails?.mobilePortInDetails?.[0]?.currentPlan?.availableValues;
  const oldNumber = portability.portabilityNumber || '';

  const portabilityCardCms = useCmsConfig(
    CONSUMER_CMS_SHOPPING_CART,
    API.CMS_GET_PORTABILITY_MOBILE
  ) as IPortabilityMobileCMS;

  const editorialLabels = evaluatePortabilityLabels(portabilityCardCms);

  const trackTransferBalance = (transferBalance: boolean) => {
    trackLink(transferBalance ? 'trasferimento credito on' : 'trasferimento credito off');
  };

  const onChangeData = (data: IPortabilityObject, isValid: boolean) => {
    if (handleOnChangeEnableGoNext) {
      const { transferBalance } = data.portabilityMigration || {};
      if (transferBalance != portability?.portabilityMigration?.transferBalance)
        trackTransferBalance(transferBalance || false);
      setPortability(data);
      if (isValid) handleOnChangeEnableGoNext(true);
    }
  };

  useEffect(() => {
    setIsValidNumberPortability(true);
  }, []);

  return (
    <div>
      <TaggingPortabilityDataCard />
      <PortabilityMigrationData
        editorialLabels={editorialLabels}
        portabilityOperatorsFirstAction={product?.portabilityOperatorsFirstAction}
        oldNumber={oldNumber}
        currentPlan={currentPlan}
        currentProvider={availableOperators}
        onChangeData={onChangeData}
        handleOnChangeEnableGoNext={handleOnChangeEnableGoNext}
      />
    </div>
  );
};

export default PortabilityDataCard;
